import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import "./ficheContact.scss"
import Links from './links'
import Headband from 'components/headband/headband'
import { Link } from 'react-router-dom'
import crumbContext from "contexts/crumbs"
export default function FicheContact() {
    const {setHeadband} = useContext(headbandContext)
    const {crumbs} = useContext(crumbContext)
    useEffect(() => {
        console.log(crumbs)
        setHeadband({
            title :  "Fiche contact",
            icon : "picto_fiche_contact.svg",
            color : "bckGreen"
        })
    }, [])
    const liste = [
        {
            picto : "picto_compte_personnel_formation.svg",
            text : "Compte personnel de formation (CPF)",
            url : "/accueil/parcours_evolution/cpf"
        },
        {
            picto : "picto_conge_formation.svg",
            text : "Congé de formation professionnelle (CFP)",
            url : "/accueil/parcours_evolution/cfp"
        },
        {
            picto : "picto_bilan_de_competence.svg",
            text : "Bilan de compétence (BC)",
            url : "/accueil/parcours_evolution/bilan_competence"
        },
        {
            picto : "picto_validation_acquis_experience.svg",
            text : "Validation des acquis (VAE)",
            url : "/accueil/parcours_evolution/vae"
        },
        // {
        //     picto : "icone_CHU_Rouen_vert.svg",
        //     text : "Reconversion professionnelle",
        //     url : "/accueil/drhf/fiche_contact/reconversion"
        // },
        {
            picto : "picto_etudes_promotionnelles.svg",
            text : "Études promotionnelles (ÉP)",
            url : "/accueil/parcours_evolution/etudes_Promotionnelles"
        },
    ]
    return (
        <div id="ficheContact" className='page flex column flexStart'>
            <h2>Dispositifs individuels de formation</h2>
            <h3>ou pour tout renseignement sur les parcours professionnels</h3>
            <div className='w100 flex between' style={{marginTop : "30px"}}>
                <div style={{width : "200px"}} className="centerImg">
                    <img src="/finger_blue.svg" alt="" />
                </div>
                <div className='flex wrap between'style={{width : "950px"}} >
                    {
                        liste.map((e, i) => <Links text={e.text} url={e.url} picto={e.picto} key={i} color={"bckRed"}/>)
                    }
                </div>
            </div>

            <Headband
                name="Janick MALANDAIN – Thomas LEGRIX" 
                fonction="Secrétariat" 
                color="bckGreen"
                icon="picto_trombinoscope.svg"
                url="/accueil/parcours_evolution/trombinoscope_parcours_pro"
                title="Trombinoscope"
                accueil={[
                    {
                        name :"Nathalie GASTEBOIS",
                        phone : "02 32 88 80 14 / poste 68 014"
                    },
                    {
                        name :"Kelly BERNAL",
                        phone : "02 32 88 13 28 / poste 61 328"
                    },
                ]}
            />


            <h2>Formation continue</h2>
            <h3>Pour toutes demandes de renseignements sur la formation des agents du CHU (personnel non médical uniquement)</h3>
            <Headband
                name="Catherine GUYON" 
                fonction="Accueil – Secrétariat" 
                color="bckGreen"
                icon="picto_trombinoscope.svg"
                url="/accueil/parcours_formation/trombinoscope_formation"
                title="Trombinoscope"
                accueil={[
                    {
                        name :"Catherine PETITPAS",
                        phone : "02 32 88 80 85 / poste 68 085"
                    },
                ]}
            />
        </div>
    )
}
